import request from './axios';

// 获取打单员列表
export function getPrinterOperators(params) {
  return request({
    url: '/manage/printer-operators',
    method: 'get',
    params
  });
}

// 创建打单员
export function createPrinterOperator(data) {
  return request({
    url: '/manage/printer-operators',
    method: 'post',
    data
  });
}

// 绑定打单员
export function bindPrinterOperator(id, data) {
  return request({
    url: `/manage/printer-operators/${id}/bind`,
    method: 'post',
    data
  });
}

// 解绑打单员
export function unbindPrinterOperator(id) {
  return request({
    url: `/manage/printer-operators/${id}/unbind`,
    method: 'post'
  });
}
